import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState, useEffect } from 'react';
import new_photo from 'assets/images/new_transparent.png';
import { axiosInstance } from 'utils/axios';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

function StickyHeadTable({ records, fetchRecords }) {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const token = useSelector(selectCurrentToken);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    
    const openApproveDepositModal = (row) => {
        setSelectedCustomerRow(row);
        setApproveDepositModalOpen(true);
    };

    const openRejectDepositModal = (row) => {
        setSelectedCustomerRow(row);
        setRejectDepositModalOpen(true);
    };

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="id" style={{ minWidth: 170 }}>{t("withdrawal.date")}</TableCell>
                                <TableCell key="email" style={{ minWidth: 170 }}>Email</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {records.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        <TableCell key='id' style={{fontSize: "12px"}}>
                                            ID : {row.id} <br/>
                                            {t("withdrawal.createdAt")} {
                                            `${row.createdDate.split('T')[0]} ${new Date(
                                                '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                            ).toLocaleTimeString('en-US', {
                                                timeZone: 'UTC',
                                                hour12: true,
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                second: 'numeric'
                                            })}`}
                                        </TableCell>
                                        <TableCell key='email' style={{fontSize: "12px"}}>
                                            {row.email}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={records.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </>
    );
}

export default StickyHeadTable;
